export default __webpack_public_path__ + "static/media/Phone.f0e4e3ab.svg";